import get from 'lodash/fp/get';

import { BaseApiError } from '@lumapps/base-api';
import { getEvents, GetEventsParams } from '@lumapps/events/api/getEvents';
import { BaseLoadingStatus } from '@lumapps/utils/types/BaseLoadingStatus';

import { EVENT_PICKER_FILTER_TYPES, RequestParams } from '../../types';
import { getTemporalityFilterValue } from '../../utils';
import { actions } from '../slice';

export const fetchEventList =
    (dispatchAction: React.Dispatch<any>) =>
    async ({ searchValue, filters, sortField, siteIds }: RequestParams) => {
        const communityIds = filters.find((filter) => filter.id === EVENT_PICKER_FILTER_TYPES.COMMUNITIES)?.value;
        const temporalityFilter = filters.find((filter) => filter.id !== EVENT_PICKER_FILTER_TYPES.COMMUNITIES);
        const { startAfter, endBefore, endAfter } = getTemporalityFilterValue(temporalityFilter?.value[0]);
        const params: GetEventsParams = {
            sortDirection: sortField.id,
            siteIds,
        };

        if (communityIds && communityIds[0] !== 'All') {
            params.communityIds = communityIds;
        }

        if (searchValue) {
            params.title = searchValue;
        }

        if (startAfter) {
            params.startAfter = startAfter;
        }

        if (endBefore) {
            params.endBefore = endBefore;
        }

        if (endAfter) {
            params.endAfter = endAfter;
        }

        try {
            const result = await getEvents(params);
            const events = result.items;

            const ids = events.map(get('id'));

            dispatchAction(
                actions.updateResult({
                    ids: ids as string[],
                    cursor: result.cursor,
                    hasMore: result.more,
                    items: events,
                    params,
                    append: false,
                }),
            );
            dispatchAction(actions.setStatus(BaseLoadingStatus.idle));
        } catch (error) {
            if (error instanceof BaseApiError) {
                if (error.response?.status === 404) {
                    dispatchAction(
                        actions.updateResult({
                            ids: [],
                            hasMore: false,
                            items: [],
                            params,
                            append: false,
                        }),
                    );
                    dispatchAction(actions.setStatus(BaseLoadingStatus.idle));
                }
            }

            dispatchAction(actions.setStatus(BaseLoadingStatus.error));
        }
    };
